import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import LoginService from "../../services/login.service";
    

    function IntegrationsFormatter(params, observableOptions) {

        var self = this;

        self.observableOptions = observableOptions;

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function ComposeData(sourceList) {
        if (!sourceList) {
            return {
                integrationSupported: false,
                rows: []
            };
        }

        var finalList = [];

        sourceList.forEach(function (item) {
            finalList.push({
                name: item.name || item.type,
                _origObj: item
            });
        });

        return {
            integrationSupported: true,
            rows: finalList
        };
    }

    IntegrationsFormatter.prototype.RefreshData = function () {
        var self = this;

        self.observableFormattedData(ComposeData(
            self.sourceList()
        ));
    };

    IntegrationsFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    IntegrationsFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    IntegrationsFormatter.prototype.initialize = function (dataRepository, dataProvider) {
        var self = this;

        self.dataRepository = dataRepository;
        self.userId = LoginService.userObject.userId;

        self.sourceList = dataRepository.integrations;

        if (self.sourceList) {
            self.subscriptions.push(self.sourceList.subscribe(function () {
                self.RefreshData();
            }));
        }

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(self.sourceList())) {
            self.RefreshData();
        }
    };

    IntegrationsFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    IntegrationsFormatter.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default IntegrationsFormatter;
